import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(
  (theme, { isKiteUser, isTabletMode, isMobileMode } = {}) => {
    const isTabletOnly = isTabletMode && !isMobileMode;
    const gileadFontWeight = isTabletOnly ? '700' : '600';

    return {
      relative: { position: 'relative' },
      caption: {
        color: '#929A92',
        position: 'absolute',
        fontSize: 12,
        top: 15,
      },
      linkText: {
        color: isKiteUser ? theme.palette.primary1 : theme.palette.pressed,
        display: 'block',
        fontWeight: isKiteUser ? '400' : gileadFontWeight,
        textDecoration: 'none',
        fontStyle: 'normal',
        fontSize: isTabletOnly ? '18px' : '14px',
        lineHeight: '20px',
        letterSpacing: '0.1px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    };
  },
);
